import React from "react";
import { Mail, Facebook, PhoneIcon } from "lucide-react";

const ContactBox = () => {
    return (
        <div className="bg-white border border-halloween-orange/30 shadow-halloween-purple/10 rounded-xl p-5 shadow-md max-w-md mx-auto mt-8">
            <h2 className="text-lg font-bold mb-4 flex items-center gap-2">
                Liên hệ với chúng tôi
            </h2>

            <div className="space-y-3 text-gray-700">
                <div className="flex items-center gap-2">
                    <Mail size={18} className="text-[#3F6033]" />
                    <a href="mailto:nhontrachtoday@gmail.com" className="hover:underline">
                        nhontrachtoday@gmail.com
                    </a>
                </div>

                <div className="flex items-center gap-2">
                    <Facebook size={18} className="text-[#3F6033]" />
                    <a
                        href="https://www.facebook.com/nhontrach.today2024/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="hover:underline"
                    >
                        Nhơn Trạch Hôm Nay Fanpage
                    </a>
                </div>

                <div className="flex items-center gap-2">
                    <PhoneIcon size={18} className="text-[#3F6033]" />
                    <a href="tel:+84769884612" className="hover:underline">
                        (+84) 769 884 612
                    </a>
                </div>
            </div>

            <p className="text-center text-sm text-gray-500 mt-4">
                © 2025 HNC. All rights reserved.
            </p>
        </div>
    );
};

export default ContactBox;
